import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-16" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-17" data-mp="pj6c83lngiqh">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-18" data-mp="avd0itzoq0d6">
          5 Exclusive Strategic Business Bonuses
        </h2>
        <p className="mt-2 text-center text-sm text-ink/60" data-id="element-19" data-mp="1un5vtm5ug11">
          Valued at{' '}
          <span className="font-bold text-amber-700 line-through" data-id="element-20" data-mp="5w0c44t60l8h">
            $148 USD
          </span>{' '}
          — Included <span className="font-bold text-brand" data-id="element-21" data-mp="3o24w6539q3vw">FREE</span> today
        </p>

        <ol className="mt-9 space-y-4" data-id="element-22" data-mp="3t0ok2b1f9pqw">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-start gap-4 rounded-2xl bg-white p-5 shadow-[0_1px_3px_rgba(20,17,15,0.06)]" data-id="element-23" data-mp="3t2sp4wb24usr" data-mpi={index}>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-sm font-bold text-white" data-id="element-24" data-mp="1r8td28q429f0">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-40 w-28 shrink-0 rounded-lg object-cover shadow-[0_10px_24px_-10px_rgba(20,17,15,0.45)] sm:h-48 sm:w-36" data-id="element-25" data-mp="3detuovipessk" />
              <div className="flex-1" data-id="element-26" data-mp="3n79apnafx7at">
                <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1" data-id="element-27" data-mp="2zesiijwznyxs">
                  <h3 className="font-display text-sm font-bold leading-snug text-ink" data-id="element-28" data-mp="2uh0uw23dmyze">
                    {bonus.title}
                  </h3>
                  <span className="text-[11px] font-bold uppercase tracking-wide text-brand" data-id="element-29" data-mp="38hjz0y4q1kwa">
                    Free
                  </span>
                </div>
                <p className="mt-1 text-[11px] leading-relaxed text-ink/55" data-id="element-30" data-mp="nozzcsh3ec9n">
                  {bonus.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}